import {
  Field,
  FieldContent,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldLegend,
  FieldSeparator,
  FieldSet,
  FieldTitle,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { adminFormOptions } from "../shared";
import {
  RadioGroup,
  RadioGroupItem,
} from "@/client/components/shad/radio-group";

export const RoleBlock = withForm({
  ...adminFormOptions,
  render: function Render({ form }) {
    return (
      <FieldSet>
        <FieldLegend>User Role</FieldLegend>
        <FieldDescription>
          Assign the user's access level (ADMIN: full system access, USER:
          restricted access) and their rank.
        </FieldDescription>

        <FieldGroup>
          <Field>
            <form.AppField name="role">
              {(field) => (
                <RadioGroup
                  name={field.name}
                  value={field.state.value}
                  onValueChange={(value: "ADMIN" | "USER") =>
                    field.handleChange(value)
                  }
                >
                  <Field orientation="horizontal">
                    <FieldLabel htmlFor={`form-tanstack-radiogroup-user`}>
                      <Field orientation="horizontal">
                        <FieldContent>
                          <FieldTitle>User</FieldTitle>
                          <FieldDescription>Restricted access</FieldDescription>
                        </FieldContent>
                        <RadioGroupItem
                          value="USER"
                          id={`form-tanstack-radiogroup-user`}
                        />
                      </Field>
                    </FieldLabel>
                    <FieldLabel htmlFor={`form-tanstack-radiogroup-admin`}>
                      <Field orientation="horizontal">
                        <FieldContent>
                          <FieldTitle>Admin</FieldTitle>
                          <FieldDescription>
                            Full system access
                          </FieldDescription>
                        </FieldContent>
                        <RadioGroupItem
                          value="ADMIN"
                          id={`form-tanstack-radiogroup-admin`}
                        />
                      </Field>
                    </FieldLabel>
                  </Field>
                </RadioGroup>
              )}
            </form.AppField>
          </Field>
          {/*<FieldSeparator />*/}
          <Field>
            <form.AppField name="rank">
              {(field) => <field.TextField label="Rank (Optional)" />}
            </form.AppField>
          </Field>
        </FieldGroup>
      </FieldSet>
    );
  },
});
